import React from 'react'
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import { createTheme, ThemeProvider } from '@mui/material/styles';
import { red } from '@mui/material/colors';
import { useNavigate } from "react-router-dom";


export default function LandingDropdown() {
  const navigate = useNavigate()

    const theme = createTheme({
        palette: {
          primary: {
            main: red[500],
          },
          secondary: {
            main: '#f44336',
          },
        },
    });

    
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
      setAnchorEl(null);
    };

    const LEAVE_URL = "https://form.jotform.com/231158623817054";
    const DAILY_ENG_TIMESHEET = "https://form.jotform.com/231857679590877";
    const IT_SUPPORT_FORM = "https://form.jotform.com/231648879625068"
    const handleQuickAccess = (linkName, typeOfLink) => {

      if (typeOfLink === "jotform") {
        const anchor = document.createElement('a');
        if (linkName === "leaveForm") {
          anchor.href = LEAVE_URL;
        }
        
        if (linkName === "engTimesheet") {
          anchor.href = DAILY_ENG_TIMESHEET;
        }
  
        if (linkName === "itSupport") {
          anchor.href = IT_SUPPORT_FORM;
        }
        anchor.target = '_blank';
        anchor.rel = 'noopener noreferrer';
        anchor.click();
      }
      
      else {
        navigate(`/allForms/${linkName}`)
      }
    }

  return  (
  
    <ThemeProvider theme={theme}>

      <div>
      <Button
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        color = 'primary'
        sx = {{
          bgcolor: 'tomato',
          textTransform: 'none',
          color:'white',
          ":hover": {
            bgcolor: "tomato",
          }
        }}
      >
        Quick Access ▼
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
        'aria-labelledby': 'basic-button',
        }}
      >
        <div className='quick-access-subheading'>Forms</div>
        <MenuItem onClick={()=> {handleQuickAccess("leaveForm", "jotform")}} >Leave Request Form</MenuItem>
        <MenuItem onClick={()=> {handleQuickAccess("itSupport", "jotform")}} >IT Support</MenuItem>
        {/* <MenuItem onClick={()=> {handleQuickAccess("OrderRequisitionForm", "portal")}} >Order Requisition Form</MenuItem> */}
        <div className='quick-access-subheading'>Engineering</div>
        <MenuItem onClick={()=> {handleQuickAccess("engTimesheet", "jotform")}}>Timesheet</MenuItem>
      </Menu>
      </div>
    </ThemeProvider>
  );
}
